import { request } from '../../request';

export const sizesFetch = () => {
	return request({ url: '/shop/sizes' });
};
